import { atom } from 'jotai';

export const allTurbAtom = atom([]);
